import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Router from 'www/router'
import App from 'www/app.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    router: Router,
    render: h => h(App)
  }).$mount()
  document.body.appendChild(app.$el)
})
